import { render, staticRenderFns } from "./ReportsAppDetail.vue?vue&type=template&id=361d5714"
import script from "./ReportsAppDetail.vue?vue&type=script&lang=js"
export * from "./ReportsAppDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports